import React from "react";
import WorkMenu from "../components/Work/WorkMenu";
import Slide from "react-reveal/Slide";

const WorkPage = () => {
  return (
    <Slide left>
      <WorkMenu />
    </Slide>
  );
};

export default WorkPage;
